import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
// Manejo centralizado de errores.

import axiosOriginal from 'axios';
import {
  Button,
  CircularProgress,
  Grid, InputLabel, MenuItem,
  TextField, Typography, IconButton,
  Dialog, DialogTitle, DialogContent, Checkbox, FormControlLabel,
  FormControl, Select, Chip,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloseIcon from '@material-ui/icons/Close';
import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

import { postNewTicket } from '../../requests/api/ticket';
import getUsersByBranch from '../../requests/api/notify-users';
import locationActions from '../../actions/locations';
import bytesToSize from '../../utils/bytesToSize';
import Snackbar from '../../components/Snackbar';

import useStyles from './styles';

//  id de compañias para correo
const company_email = [102, 109, 105];

const NewChallengeModal = ({ open, setOpenNewChallengeModal, sendResponse }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [error, setError] = useState('');
  //  Variable que maneja el cierre del selector al seleccionar una sucursal
  const [locationSelectOpen, setLocationSelectOpen] = useState(false);
  const [inputValues, setInputValues] = useState({
    subject: 'Challenge',
    content: '',
    category: 'Challenge',
    subcategory: 'Challenge',
    projectId: '',
    locationId: '',
  });
  // Agrega el estado para controlar el checkbox
  const [sendEmailNotification, setSendEmailNotification] = useState(false);
  // Mostrar check box solo para siertas compañias
  const [showCheckbox, setShowCheckbox] = useState(false);
  // Mostrar selector multiple solo para siertas compañias
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const projects = useSelector((state) => state.projects.projects);
  const locations = useSelector((state) => state.locations.locations || []);
  const company = useSelector((state) => state.company);

  const companyIdRef = useRef(company.companyId);
  companyIdRef.current = company.companyId;

  useEffect(() => {
    dispatch(locationActions.actionFetchLocations(companyIdRef.current));
  }, [dispatch]);

  useEffect(() => {
    setShowCheckbox(company_email.includes(company.companyId));
  }, [company.companyId]);

  useEffect(() => {
    setIsMultiSelect(company_email.includes(company.companyId));
  }, [company.companyId]);

  const handleClose = () => {
    setOpenNewChallengeModal(false);
  };

  const handleRemoveAll = () => {
    setFile(null);
  };

  const handleSelect = ({ target }) => {
    setFile(target.files[0]);
    setError('');
  };
  // Maneja el cambio de estado del checkbox
  const handleCheckboxChange = (event) => {
    setSendEmailNotification(event.target.checked);
  };
  const selectProject = (e) => {
    const { value } = e.target;
    setInputValues({
      ...inputValues,
      projectId: value,
      locationId: [], // limpiamos selección de sucursales al cambiar de proyecto
    });
  };
  // Se usa para borrar las sucursales al seleccionar multiples
  const handleDeleteLocation = (idToDelete) => {
    setInputValues((prev) => ({
      ...prev,
      locationId: prev.locationId.filter((id) => id !== idToDelete),
    }));
  };

  const selectLocation = (e) => {
    const { value } = e.target;
    setInputValues((prev) => ({
      ...prev,
      // Validación si es que el array de location viene en formato texto.
      locationId: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const handleUpload = async () => {
    setLoading(true);
    const fileParts = file.name.split('.');
    const timestamp = Date.now();
    const fileName = location.pathname === '/support'
      ? fileParts[0]
      : `${fileParts[0]} ${timestamp}`;
    const uploadData = {
      fileName,
      fileType: file.type,
    };
    const response = await axiosOriginal.post('/api/ticket/signS3', uploadData);
    const options = {
      headers: {
        'Content-Type': file.type,
        'Content-Disposition': 'attachment',
      },
    };
    const { returnData } = response.data.data;
    const { signedRequest } = returnData;
    try {
      const uploadResponse = await axiosOriginal.put(
        signedRequest,
        file,
        options,
      );
      if (uploadResponse.status === 200) {
        const fileUrl = uploadResponse.config.url.split('?')[0];
        setError('');
        setLoading(false);
        return fileUrl;
      }
    } catch (err) {
      setError(t('support.ticketForm.errorUpload'));
      return err;
    }
    return false;
  };

  const handleApiError = (err) => {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = err.response?.data?.data?.errorMessage || 'Ha ocurrido un error. Intente nuevamente.';

    return {
      success: false,
      status,
      message,
      data: { errorMessage },
    };
  };

  // Enviar correo a usuarios dependiendo de la sucursal asignada
  const sendEmailToBranchUsers = async (locationIds, message, fileUrl = null) => {
    try {
      // Asegurar que locationIds sea un array
      const ids = Array.isArray(locationIds) ? locationIds : [locationIds];

      // Obtener usuarios de todas las sucursales
      const response = await getUsersByBranch();
      const locations = response.data?.data?.locations || [];

      if (!response.success || locations.length === 0 || ids.length === 0) {
        return;
      }

      // Filtrar las sucursales seleccionadas
      const selectedLocations = locations.filter((loc) => ids.includes(Number(loc.locationId)));

      if (selectedLocations.length === 0) {
        return;
      }

      // Recolectar todos los emails únicos de usuarios
      const emails = [
        ...new Set(
          selectedLocations.map((loc) => loc.User.email).filter(Boolean),
        ),
      ];

      if (emails.length === 0) {
        return;
      }

      // Obtener los nombres de las sucursales para el asunto
      const locationNames = Array.from(
        new Set(
          selectedLocations
            .map((loc) => loc.Location?.name)
            .filter(Boolean),
        ),
      ).join(', ');

      const emailSubject = `Notificación - ${locationNames}`;
      const emailContent = message;

      // Construir payload
      const payload = {
        emails,
        subject: emailSubject,
        message: emailContent,
      };

      if (fileUrl) {
        payload.fileUrl = fileUrl;
      }

      // Enviar correo
      const { data } = await axios.post('/api/send-email-ripley', payload);

      return {
        success: data.success,
        status: data.status,
        message: data.message,
        data,
      };
    } catch (err) {
      return handleApiError(err);
    }
  };

  const handleSend = async () => {
    let postTicketResponse = [];
    let fileUrl = null;

    const isLocationEmpty = Array.isArray(inputValues.locationId)
      ? inputValues.locationId.length === 0
      : !inputValues.locationId;

    if (
      !inputValues.subject
        || !inputValues.content
        || !inputValues.category
        || !inputValues.subcategory
        || !inputValues.projectId
        || isLocationEmpty
    ) {
      setError(t('support.ticketForm.required'));
      return;
    }

    // Subir archivo a S3
    if (file) {
      fileUrl = await handleUpload();
      if (!fileUrl) return;
    }

    // Envío de correo
    if (sendEmailNotification) {
      await sendEmailToBranchUsers(inputValues.locationId, inputValues.content, fileUrl);
    }

    // Crear un ticket por cada sucursal seleccionada
    const locationIds = Array.isArray(inputValues.locationId)
      ? inputValues.locationId
      : [inputValues.locationId];

    const responses = await Promise.all(
      locationIds.map((locationId) => postNewTicket({
        subject: inputValues.subject,
        content: inputValues.content,
        category: inputValues.category,
        subcategory: inputValues.subcategory,
        projectId: inputValues.projectId,
        locationId,
        fileUrl: fileUrl || undefined,
        startDate: inputValues.startDate,
        endDate: inputValues.endDate,
      })),
    );

    postTicketResponse = responses.filter((response) => response.success);
    if (postTicketResponse.length > 0) {
      handleClose();
      setInputValues({
        subject: '',
        content: '',
        category: '',
        subcategory: '',
        projectId: '',
        locationId: [],
      });
      sendResponse({ success: true });
    } else {
      setError('No se pudo crear ningún ticket. Intente nuevamente.');
    }
  };

  const uploaderRender = () => {
    if (file) {
      return (
        <Grid container item className={styles.uploadContainer}>
          <Grid item className={styles.fileInfo}>
            <Typography variant='body1' className={styles.fileName}>{file.name}</Typography>
            <Typography variant='body2' className={styles.fileSize}>{bytesToSize(file.size)}</Typography>
          </Grid>
          <Grid item>
            <div className={styles.actions}>
              {loading ? (
                <CircularProgress />
              ) : (
                <ClearIcon
                  onClick={handleRemoveAll}
                  className={styles.uploadIcon}
                  fontSize='large'
                />
              )}
            </div>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid
        container
        item
        justifyContent='center'
        alignItems='center'
        className={styles.buttonContainer}
      >
        <input
          className={styles.input}
          id='contained-button-file'
          multiple
          type='file'
          onChange={handleSelect}
        />
        <label htmlFor='contained-button-file'>
          <Button variant='contained' component='span' className={styles.uploadButton}>
            <CloudUploadIcon />
            <span>{t('support.ticketForm.uploadFile')}</span>
          </Button>
        </label>
      </Grid>
    );
  };

  const today = new Date().toISOString().split('T')[0];

  const challengeForm = () => (
    <Grid
      container
      spacing={2}
      alignItems='flex-end'
      style={{ padding: '16px 0 0 0' }}
    >
      <Grid
        xs={12}
        item
        container
        spacing={2}
        alignItems='center'
        justifyContent='space-between'
        style={{ padding: '0 0 0 8px' }}
      >
      </Grid>
      <Grid item xs={12}>
        <InputLabel>{t('support.challengeForm.description')}</InputLabel>
        <TextField
          variant='outlined'
          id='content'
          value={inputValues.content}
          onChange={(e) => setInputValues({ ...inputValues, content: e.target.value })}
          fullWidth
          multiline
          minRows={3}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Fecha Inicio:"
          type="date"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: today, // límite inferior
          }}
          style={{ width: '50%' }}
          value={inputValues.startDate}
          variant="outlined"
          onChange={(e) => setInputValues({ ...inputValues, startDate: e.target.value })}
        />
        <TextField
          label="Fecha Fin:"
          type="date"
          style={{ width: '50%' }}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: today, // límite inferior
          }}
          value={inputValues.endDate}
          variant="outlined"
          onChange={(e) => setInputValues({ ...inputValues, endDate: e.target.value })}
        />
      </Grid>
      <Grid item xs={12}>
        <InputLabel>{t('support.ticketForm.project')}</InputLabel>
        <TextField
          id='projectId'
          type='text'
          variant='outlined'
          value={inputValues.projectId}
          onChange={selectProject}
          select={true}
          fullWidth
        >
          {projects.map((project) => (
            <MenuItem key={project.projectId} value={project.projectId}>
              {project.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {isMultiSelect ? (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>{t('support.ticketForm.location')}</InputLabel>
              <Select
                id="locationId"
                multiple
                open={locationSelectOpen}
                onClose={() => setLocationSelectOpen(false)}
                onOpen={() => setLocationSelectOpen(true)}
                value={inputValues.locationId}
                onChange={(event) => {
                  selectLocation(event);
                }}
                label={t('support.ticketForm.location')}
                renderValue={(selected) => (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {selected.map((id) => {
                      const loc = locations.find((l) => l.locationId === id);
                      return (
                        <div key={id} onMouseDown={(event) => event.stopPropagation()}>
                          <Chip
                            label={loc?.Location?.name || id}
                            size="small"
                            onDelete={() => handleDeleteLocation(id)}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              >
                {locations
                  .filter((l) => l.projectId === inputValues.projectId)
                  .map((l) => (
                    <MenuItem key={l.locationId} value={l.locationId}>
                      {l.Location.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
      ) : (
          <Grid item xs={12}>
            <InputLabel>{t('support.ticketForm.location')}</InputLabel>
            <TextField
              id="locationId"
              type="text"
              variant="outlined"
              value={inputValues.locationId}
              onChange={selectLocation}
              select
              fullWidth
            >
              {locations
                .filter((l) => l.projectId === inputValues.projectId)
                .map((l) => (
                  <MenuItem key={l.locationId} value={l.locationId}>
                    {l.Location.name}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
      )}
      <Grid item xs={8} style={{ position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
        {uploaderRender()}
      </Grid>
      {showCheckbox && (
          <Grid item xs={8}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={sendEmailNotification}
                  onChange={handleCheckboxChange}
                />
              }
              label="Enviar notificación por correo"
            />
          </Grid>
      )}
      <Grid item xs={4}>
        <Button
          id='submit-ticket-btn'
          onClick={handleSend}
          variant='contained'
          color='primary'
          fullWidth
        >
          {t('support.ticketForm.button')}
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
      <DialogTitle className={styles.dialogTitle}>
        {t('support.challengeForm.title')}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          className={styles.closeIcon}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={styles.dialogContent}>
        {projects && challengeForm()}
      </DialogContent>
      <Snackbar
        open={error !== ''}
        message={error}
        severity='error'
        onClose={() => setError('')}
      />
    </Dialog>
  );
};

export default NewChallengeModal;
